import React from 'react'
import axios from 'axios'

const {
    REACT_APP_DATABASE_BASEURL_DEV,
    REACT_APP_DATABASE_BASEURL,
    REACT_APP_NODE_ENV
} = process.env;

const PlayListModal = ({
    modalTitle,
    socket,
    generateHeaderCloseIco,
    songs,
    currUser,
    getSongs,
    setType,
    setCurrSingleUserName,
    setSongIndex,
    setPlay,
    setAnimationString
}) => {

    const handleSongChange = (songIndex) => {
        setAnimationString('none')
        setSongIndex(songIndex)
        setPlay(true)
    }


    const handleDeleteSong = async (id) => {
        const response = await axios.delete(`${REACT_APP_NODE_ENV === 'development' ? REACT_APP_DATABASE_BASEURL_DEV : REACT_APP_DATABASE_BASEURL}/song-by-id/${id}`)
        if (response.data.status === 1) {
            socket.emit('deleteSong')
        }
    }

    const handleUserSelect = (selectedName) => {
        setType('single-user')
        setCurrSingleUserName(selectedName)
    }

    const showDeleteIco = (author) => {

        if (currUser === author) {
            return true
        }

        if (currUser === 'TheCreator') {
            return true
        }

        if (currUser === 'Superadmin') {
            return true
        }

        return false
    }

    React.useEffect(() => {
        const handleUpdateSongs = () => {
            getSongs()
        }
        socket.on('updateSongs', handleUpdateSongs)

        return () => {
            socket.off('updateSongs', handleUpdateSongs)
        }
    }, [socket])

    const renderSongs = () => {

        return songs.map((song, index) => {
            return <div key={`${Math.random()}${song}`} className="relative w95">
                {showDeleteIco(song.author) && <span
                    onClick={() => { handleDeleteSong(song.id) }}
                    className="notification-number logout-ico pointer">
                    x
                </span>}
                <div className="row">
                    <p className="margin-right">{`${index + 1}.`}</p>
                    <div className="row middle">
                    <p onClick={() => {handleSongChange(index)}} className="margin-right-5 underline pointer">{song.name}</p>
                    <p>- by</p>
                    <p className="white pointer underline margin-left-5" onClick={() => { handleUserSelect(song.author)}}>{`${song.author}`}</p>
                    </div>
                </div>
            </div>


        })
    }

    return (
        <div className="pop-up">
            <div className="pop-up-content">
                <div className="pop-up__title margin-bottom">
                    <div className="pop-up__title__content">
                        {modalTitle}
                        {generateHeaderCloseIco()}
                    </div>
                </div>
                <div className="modal-content-wrapper">
                    {renderSongs()}
                </div>
            </div>
        </div>
    )

}

export default PlayListModal